/* eslint-disable @typescript-eslint/no-unused-vars,  @typescript-eslint/no-use-before-define */
/* global $ angular */
import intl from 'react-intl-universal'
import { sanitize } from 'dompurify'
import { constants } from '../contenteditablebind/directive'
import estimateLineCount from '../../util/estimateLineCount'
import { contentElementInflate } from '~/modules/routes/storyInflate'
import { composeBodyReducers } from '~/modules/contentComment/reducerTable'
import { notSelectedState as selectonNotSelectedState } from './reorderManager'
import * as R from 'ramda'
import cleanPasteHTML from '../../util/cleanPasteHTML'
import { splitHTMLAtIndex } from '../../util/htmlAttrs'
import { TypographyFlags, typographyFeedbackAction } from '~/redux/appReducer'
import { throttle } from 'lodash'
import {
  handleCutCopy,
  handleEnterSelection,
  handlePaste,
  handleRemove,
  normaliseSelectionRange,
  walkTreeOffset,
  placeCaretAfterSelectorWait,
} from './copypaste'

// eslint-disable-next-line @typescript-eslint/no-var-requires
const rangy = require('rangy')

export default [
  '$scope',
  '$rootScope',
  '$element',
  '$location',
  '$timeout',
  'contentTemplatesService',
  'storyService',
  'thirdPartyIntegrationService',
  'toastr',
  'ansService',
  'hyperlinkService',
  'afterNextClickService',
  'caretService',
  '$ngRedux',
  ComposeBody,
]

const K = {
  backspace: 8,
  delete: 46,
  enter: 13,
  escape: 27,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  space: 32,
  y: 89,
  z: 90,
}

const validators = {
  interstitial_link: (feature) => {
    return feature.content && feature.url
  },
}

const isFeatureValid = (feature) => {
  let featureType = feature.type

  if (featureType === 'quote2') {
    featureType = 'quote'
  }

  return validators[featureType] ? validators[featureType](feature) : true
}

// Utility for word count and character count
const cleanElem = (str) => {
  // Sanitize HTML string to prevent XSS
  const sanitizedHTML = sanitize(str)

  const temp = $('<div></div>').html(sanitizedHTML)
  temp.find('[paste-options], dfn, .handles, .js-formatting-popover').remove()
  return temp
    .text()
    .trim()
    .replace(/(&nbsp;|\s)+/g, ' ')
}

/*
const PasteHolderFactory = $element => {
  let instances = {}
  const factory = id => instances[id] || (instances[id] = new PasteHolder($element, id))
  factory.dismissAll = () => Object.values(instances).forEach(instance => instance.dismiss())
  factory.destroyAll = () => { instances = null }
  return factory
}
*/

export function ComposeBody(
  $scope,
  $rootScope,
  $element,
  $location,
  $timeout,
  contentTemplatesService,
  storyService,
  thirdPartyIntegrationService,
  toastr,
  ansService,
  hyperlinkService,
  afterNextClickService,
  caretService,
  $ngRedux
) {
  $scope.intl = intl

  let cleanupFunctions = []

  $scope.fontSize = window.localStorage.getItem('fontSize')

  /*
  // PasteHolder instance is responsible for temporarely holding pasted node
  const pasteHolderFactory = this.pasteHolderFactory = PasteHolderFactory($element)
  // return current paste holder instance for currently selected element
  const currentPasteHolder = () => {
    const contentElement = $scope.story.content_elements[$scope.currentFocus]
    const { additional_properties: {_id} = {} } = contentElement || {}
    if (!_id) {
      return null
    }
    return pasteHolderFactory(_id)
  }
  */

  const ensureSafeSelection = () => {
    const selection = document.getSelection()
    const range = normaliseSelectionRange(selection.getRangeAt(0))
    if (!range) {
      return
    }
    selection.removeAllRanges()
    selection.addRange(range)
  }

  this.registerPropertyValidator = (type, validatorFn) => {
    validators[type] = validatorFn
  }

  // For Checking path ng-hide & ng-show
  $scope.currentPath = $location.path()

  $scope.multiSelectionState = selectonNotSelectedState(
    storyService,
    $scope.story
  )

  const handleWordCount = (contentElements = []) => {
    const elements = !Array.isArray(contentElements)
      ? Object.keys(contentElements).reduce(
          (a, k) => [...a, contentElements[k]],
          []
        )
      : contentElements
    const cleaned = elements.map((e) => {
      const item = {
        ...e,
        content: cleanElem(e.content),
      }
      return !e.items
        ? item
        : {
            ...item,
            items: e.items.map((i) => ({
              ...i,
              content: cleanElem(i.content),
            })),
          }
    })
    return estimateLineCount(cleaned, {
      // hard code this for now
      validElements: ['text', 'list', 'header', 'blockquote'],
      wordsPerLine: ($scope.companySettings.wordCount || { wordsPerLine: 33 })
        .wordsPerLine,
      linesPerInch: ($scope.companySettings.wordCount || { linesPerInch: 7 })
        .linesPerInch,
    })
  }

  const updateFocus = (index, announce) => {
    if (index === $scope.currentFocus && !announce) {
      return
    }
    if (index === undefined) {
      index = $('.feature-focused').attr('data-org-index') || -1
    }
    $scope.currentFocus = index
    $rootScope.$broadcast('ELEMENT_FOCUS_CHANGE', {
      index,
      feature: index > -1 ? $scope.story.content_elements[index] : undefined,
    })
  }

  // need this for modal, content-tools will modify this obj
  // then it gets passed to the overlay and modal
  $scope.focusedContent = {
    index: -1,
    feature: {},
  }

  // naming is confusing...
  // but this sets child content-comment directive visibile
  // if we use focusedContent, the property modal will appear
  // dont do that
  $scope.focusedComment = -1

  cleanupFunctions.push(
    $rootScope.$on('CONTENT_COMMENT', (info, action) => {
      if (composeBodyReducers[action.type]) {
        composeBodyReducers[action.type]({
          composeBodyScope: $scope,
          action,
          storyService,
          comments: ((el = {}) => {
            return (el.additional_properties || { comments: [] }).comments
          })($scope.story.content_elements[action.index]),
        })
      }
    })
  )

  $scope.propModalConfirm = () => {
    if (!isFeatureValid($scope.focusedContent.feature)) {
      toastr.error(
        intl.get('composeBody.propModalConfirm.invalid'),
        intl.get('common.error')
      )
      return
    }

    $scope.focusedContent = {
      index: -1,
      feature: {},
    }
  }

  // $scope.currentFocus = 0

  const _updateWordCount = (action) => {
    if (action.type === constants.WORDCOUNT && !$scope.$$phase) {
      $scope.$apply(() => {
        $scope.count = handleWordCount(
          $scope.story.content_elements.map((c, i) => {
            const data = JSON.parse(JSON.stringify(c))
            delete data.$$hashKey
            if (i === action.orgIndex) {
              data.content = action.content.replace(/&nbsp;/g, '')
            }
            return data
          })
        )
      })
    }
  }

  cleanupFunctions.push(
    $rootScope.$on('DISPATCH', (info, action) => {
      _updateWordCount(action)
    })
  )

  $(document)
    .off('BROADCAST.wc')
    .on('BROADCAST.wc', (e, action) => {
      _updateWordCount(action)
    })

  $(document)
    .off('ELLIPSIS_STORY_LOADED.wc')
    .on('ELLIPSIS_STORY_LOADED.wc', (e, action) => {
      handleWordCount($scope.story.content_elements)
    })

  $scope.count = handleWordCount($scope.story.content_elements)

  cleanupFunctions.push(
    $rootScope.$on('DESTROY_ELEM', (info, action) => {
      if ($scope.story.content_elements.length > 1) {
        $scope.story.content_elements.splice(action.index, 1)
      } else {
        toastr.error(intl.get('composeBody.cleanupFunctions.error'))
      }
    })
  )

  $scope.isCurrentFocus = (index) =>
    !$scope.multiSelectionState.hasSelection() && index === $scope.currentFocus

  $scope.isFeatureSelected = (id, isFirst) =>
    $scope.multiSelectionState.isFeatureSelected(id, isFirst)

  $scope.mouseDownDelegate = (i, event) => {
    const positions = storyService.getContentElementPositions()
    const index = positions.indexOf(i)
    const transitionStateWithIndex = (index) => {
      $scope.multiSelectionState = $scope.multiSelectionState.transitionStateWith(
        index
      )
      return $scope.multiSelectionState
    }

    if (event) {
      if (event.shiftKey && index > -1) {
        transitionStateWithIndex(index)
        if ($scope.currentFocus > -1 && index !== $scope.currentFocus) {
          transitionStateWithIndex($scope.currentFocus)
        }
        // window.getSelection().removeAllRanges()
      } else {
        if (
          !$scope.multiSelectionState.isFeatureSelected(index, true) ||
          $(event.target).closest('.handle').length === 0
        ) {
          $scope.multiSelectionState = $scope.multiSelectionState.getInitial()
        }
      }
    }
  }

  const recordCursorPosition = (i, e) => {
    const positions = storyService.getContentElementPositions()
    const index = positions.indexOf(i)
    const currentFocus = index > -1 ? index : $scope.currentFocus

    angular.element('[content-element]').eq(index).addClass('feature-focused')

    updateFocus(currentFocus)

    $scope.contentElement = $(
      angular.element('[content-element]').eq($scope.currentFocus)
    ).find('p')[0]

    // if (!$scope.contentElement) { return }
    // const caretInfo = caretService.getCaretPosition(e.target, $scope.contentElement.childNodes)
    // if (e.which === 39) { caretInfo.caretPosition += 2 }
    // $scope.caretPosition = caretInfo.caretPosition - (e.type === 'keydown' ? 1 : 0)
    // $scope.childNodeWithCaretIndex = caretInfo.childNodeWithCaretIndex
  }

  // clicking on the content element focuses it by default
  // so we dont need to broadcast here, only change currentFocus state
  $scope.clickDelegate = (i, e) => {
    recordCursorPosition(i, e)
  }

  $scope.focusDelegate = (i, e) => {
    const positions = storyService.getContentElementPositions()
    const index = positions.indexOf(i)
    const currentFocus = index > -1 ? index : $scope.currentFocus

    // if ($scope.currentFocus !== currentFocus && $scope.currentFocus !== undefined) { return true }

    angular.element('[content-element]').eq(index).addClass('feature-focused')
    updateFocus(currentFocus)

    $scope.contentElement = $(
      angular.element('[content-element]').eq($scope.currentFocus)
    ).find('p')[0]

    if (!$scope.contentElement) {
      return true
    }

    caretService.setCaretPosition(
      index,
      $scope.caretPosition,
      $scope.childNodeWithCaretIndex,
      $scope.contentElement.childNodes
    )
  }

  $scope.keydownDelegate = (i, e) => {
    recordCursorPosition(i, e)
  }

  $scope.openPreview = (feature) => {
    contentTemplatesService.getPreview(feature.type)(feature)
  }

  $scope.hidePropModal = () => {
    $scope.focusedContent = {
      index: -1,
      feature: {},
    }
  }

  $scope.showPropModal = (index) => {
    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'showPropModal',
        contentType: $scope.story.content_elements[index].type,
        _id: $scope.story.content_elements[index]._id || -1,
        index,
      },
    })

    $scope.focusedContent = {
      index,
      feature: $scope.story.content_elements[index],
    }
  }

  $scope.hasPreview = (type) => {
    return contentTemplatesService.getPreview(type) !== undefined
  }
  $scope.hasProperties = (type) => {
    return contentTemplatesService.getProperties(type) !== undefined
  }

  $scope.getTitle = (feature) => {
    return feature.type === 'quote'
      ? feature.subtype_label
      : contentTemplatesService.get(feature.type).title
  }

  $scope.deleteContentElement = ($i) => {
    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'deleteContentElement',
        contentType: $scope.story.content_elements[$i].type,
        _id: $scope.story.content_elements[$i]._id || -1,
        index: $i,
      },
    })

    $scope.story.content_elements.splice($i, 1)
    if (!$scope.story.content_elements.length) {
      $scope.story.content_elements.push({ type: 'text', content: '' })
    }
    // $scope.story.content_elements.splice($i, 1)
    $scope.count = handleWordCount($scope.story.content_elements)
    pushCurrentElemStack()
  }

  function makeFragment(range, direction) {
    const wrapperElem = document.createElement('div')
    wrapperElem.contentEditable = 'true'
    let curElem = range.commonAncestorContainer

    // If we are just in the content Edtiable element it is a simple clone
    if (
      curElem &&
      (curElem.contentEditable === 'true' || $(curElem).is('[content-element]'))
    ) {
      // no inine element
      wrapperElem.appendChild(range.cloneContents())
    } else {
      // inline element, get text before
      const isBefore = direction === 'before'

      // get the element the cursor is in and clone that element without the contents
      let prevElem = curElem.cloneNode()
      let lastElem = curElem
      // se the newly created element with the range and append it to the wrapper
      if (prevElem.nodeType === 1) {
        // getting errors here so look to see if we have an element
        prevElem.appendChild(range.cloneContents())
      } else if (prevElem.parentNode) {
        // if it has a parent append it
        prevElem.parentNode.appendChild(range.cloneContents())
      } else if (prevElem.textContent) {
        // else just add the text
        prevElem.textContent =
          prevElem.textContent + (range.cloneContents().textContent || '')
      }
      wrapperElem.appendChild(prevElem)

      // while we have an element reference we need to loop over it and its children
      while (curElem) {
        lastElem = null

        // Find all the siblings of the element and add it to the wrapper
        while (
          (curElem = isBefore ? curElem.previousSibling : curElem.nextSibling)
        ) {
          const nextElem = curElem.cloneNode(true)
          if (isBefore) {
            wrapperElem.insertBefore(nextElem, prevElem)
          } else {
            wrapperElem.appendChild(nextElem)
          }
          if (prevElem.innerHTML === '') prevElem.remove()
          prevElem = nextElem
          lastElem = curElem
        }

        // Now check if the element is nested and not the content editable element
        const parNode = lastElem && lastElem.parentNode
        const isContentEditable = parNode && parNode.contentEditable === 'true'

        // If it is not content editable, than we need to clone the element and append this to the wrapper
        if (lastElem && !isContentEditable) {
          curElem = parNode
          prevElem = parNode.cloneNode()
          prevElem.innerHTML = wrapperElem.innerHTML
          wrapperElem.innerHTML = '' // clear the html since the content is now in the child
          wrapperElem.appendChild(prevElem) // add the new elemenet so we can start to look at its siblings
        }
      }
    }

    return wrapperElem.innerHTML
  }

  function getTextBeforeAfter(container) {
    const sel = window.getSelection()
    const selectionRange = sel.getRangeAt(0)
    const range = normaliseSelectionRange(selectionRange) || selectionRange
    const tempRange = document.createRange()

    const startContainer = $(range.startContainer).closest(
      '[contenteditable="true"]'
    )[0]
    tempRange.selectNodeContents(startContainer)
    tempRange.setEnd(range.startContainer, range.startOffset)
    const before = makeFragment(tempRange, 'before')

    const endContainer = $(range.endContainer).closest(
      '[contenteditable="true"]'
    )[0]
    tempRange.selectNodeContents(endContainer)
    tempRange.setStart(range.endContainer, range.endOffset)
    const after = makeFragment(tempRange, 'after')

    const cleanUpContent = (html) => {
      // Sanitize HTML string to prevent XSS
      const sanitizedHTML = sanitize(html)
      const tempElem = $('<div></div>').html(sanitizedHTML.replace(/\n+/, ''))
      tempElem.find('content-tools, .handles, [paste-options], br').remove()
      tempElem.find('[contenteditable]:empty').remove()
      tempElem.find('[contenteditable]').each((i, e) => {
        $(e).contents().unwrap()
      })
      return tempElem
    }

    const beforeElem = cleanUpContent(before)
    const afterElem = cleanUpContent(after)

    cleanPasteHTML(beforeElem)
    cleanPasteHTML(afterElem)

    return {
      before: beforeElem.html().trim(),
      after: afterElem.html().trim(),
      startContainer,
      endContainer,
    }
  }

  function placeCaretAtEnd(el) {
    el.focus()
    if (
      typeof window.getSelection !== 'undefined' &&
      typeof document.createRange !== 'undefined'
    ) {
      const range = document.createRange()
      range.selectNodeContents(el)
      range.collapse(false)
      const sel = window.getSelection()
      sel.removeAllRanges()
      sel.addRange(range)
    } else if (typeof document.body.createTextRange !== 'undefined') {
      const textRange = document.body.createTextRange()
      textRange.moveToElementText(el)
      textRange.collapse(false)
      textRange.select()
    }
  }

  function handleEnter(
    enterElem,
    scope,
    contentElements,
    ignoreNewAfter,
    pasting
  ) {
    const elemWrapper = $(enterElem).closest('[data-type]')
    const elementType = elemWrapper.data('type')
    const elementIndex = elemWrapper.prevAll('[data-type]').length // location of the element we have focused

    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'handleEnter',
        contentType: elementType,
        _id: elemWrapper._id || -1,
        index: elementIndex,
      },
    })

    if (elementType === 'list') {
      const liObjItems = contentElements[elementIndex].items
      const activeElem = $(enterElem).is('ul')
        ? window.getSelection().anchorNode
        : enterElem
      const currentLi = $(activeElem).closest('li')

      const currentLiIndex = currentLi.prevAll('li').length
      const text = currentLi.length
        ? getTextBeforeAfter(currentLi[0])
        : { before: '', after: '' }
      const isEmpty = !text.before.length && !text.after.length

      const lSel = window.getSelection()
      const aNode = lSel.anchorNode
      const eNode = lSel.extentNode
      const anLi = aNode.parentElement.closest('li')
      const enLi = eNode.parentElement.closest('li')

      if (anLi !== enLi) {
        const lStart = walkTreeOffset(aNode, lSel.anchorOffset)
        const lEnd = walkTreeOffset(eNode, lSel.extentOffset)
        const lHTMLStart = splitHTMLAtIndex(anLi.innerHTML, lStart)
        const lHTMLEnd = splitHTMLAtIndex(enLi.innerHTML, lEnd)
        const anIndex = $(anLi).prevAll('li').length
        const enIndex = $(enLi).prevAll('li').length
        const ulObjItems = contentElements[elementIndex].items
        const ts = 'curFocus' + new Date().getTime()
        ulObjItems[anIndex].content = lHTMLStart.lead
        ulObjItems[enIndex].content =
          `<span class='${ts}'></span>` + lHTMLEnd.tail
        const diff = enIndex - currentLiIndex
        if (diff > 1) {
          ulObjItems.splice(currentLiIndex + 1, diff - 1)
        }
        placeCaretAfterSelectorWait('.' + ts)
        return true
      } else if (!isEmpty) {
        // If the li is not empty, means we want to add a new LI to the UL
        // updateTextElems(scope, currentLi, activeElem, currentLiIndex, liObjItems)
        // deal with it here instead of that other code
        const ts1 = 'curFocus' + new Date().getTime()
        liObjItems.splice(
          currentLi.index(),
          1,
          { type: 'text', content: `${text.before}` },
          { type: 'text', content: `<span class='${ts1}'></span>${text.after}` }
        )
        placeCaretAfterSelectorWait('.' + ts1)
        return true
      } else if (
        liObjItems.length - 1 === currentLiIndex ||
        !currentLi.length
      ) {
        // If the li is empty and the last one, we want to add  new paragraph after the list
        // remove the last li
        contentElements[elementIndex].items.splice(
          contentElements[elementIndex].items.length - 1,
          1
        )
        // Add text element after the list
        addNewElement($scope, elementIndex + 1, {
          type: 'text',
          content: '<br>',
        })
        return true
      } else if (isEmpty) {
        // if the user selected all the text in the element, than remove it
        if (lSel.toString().length > 0) {
          liObjItems[currentLi.index()].content = '<br>'
        }
        // now add the li after it
        liObjItems.splice(currentLi.index(), 0, {
          type: 'text',
          content: '<br>',
        })
        return false
      }
      return true
    } else if (elementType === 'table') {
      let _id = new Date().getTime()
      const nextId = function () {
        _id++
        return _id.toString()
      }

      const td = $(enterElem).closest('td')
      const row = td.closest('tr')
      const tbody = $(enterElem).closest('tbody')
      if (
        tbody.length &&
        (!td.next().length || (!td.prev().length && !row.prev().length))
      ) {
        // if last cell
        let rowIndex = row.prevAll('tr').length
        const rowObjects = contentElements[elementIndex].rows
        const currentRow = rowObjects[rowIndex]
        const rowClone = JSON.parse(JSON.stringify(currentRow))
        let selectionMethod = 'prev'
        rowClone.forEach((td) => {
          delete td.$$hashKey
          td.content = ''
          td._id = nextId()
        })
        delete rowClone.$$hashKey
        if (!td.next().length) {
          rowIndex += 1
          selectionMethod = 'next'
        }
        rowObjects.splice(rowIndex, 0, rowClone)
        scope.$apply()
        row[selectionMethod]().find('td').first().focus()
        return true
      }
    } else if (
      elementType === 'text' ||
      elementType === 'header' ||
      elementType === 'blockquote'
    ) {
      updateTextElems(
        scope,
        elemWrapper,
        enterElem,
        elementIndex,
        contentElements,
        pasting
      )
      return true
    }
  }

  const _contentElementAction = (obj) => {
    const ind = parseInt(obj.index)
    const cea = {
      action: obj.action || 'no-op',
      index: isNaN(ind) ? -1 : ind,
      feature: obj.feature || {},
    }
    return cea
  }

  const notifyDelete = (from, to) => {
    const getIndex = (feature) => {
      const featureObj = angular.element(feature[0])
      return +featureObj[0].dataset.orgIndex
    }
    const [startIndex, endIndex] = [getIndex(from), getIndex(to)]
    let count = endIndex - startIndex + 1
    while (count-- > 0) {
      const ce = $scope.story.content_elements[startIndex]
      const cea = _contentElementAction({
        index: startIndex,
        feature: ce,
        action: 'delete',
      })
      $rootScope.$broadcast('UPDATE_CONTENT_ELEMENT', cea)
    }
  }

  function deleteFeature(featureOrTextObj, shouldfocusAfter = false) {
    // If last Feature, don't loose focus
    if ($scope.story.content_elements.length === 1) return

    const selection = window.getSelection()

    let startContainer =
      selection.baseNode.parentNode.closest('[content-element]') ||
      featureOrTextObj ||
      {}
    let endContainer =
      selection.extentNode.parentNode.closest('[content-element]') ||
      featureOrTextObj ||
      {}

    const startIndex = $(startContainer).index()
    const endIndex = $(endContainer).index()
    let anchorOffset = selection.anchorOffset
    let extentOffset = selection.extentOffset
    let anchorNode = selection.anchorNode
    let extentNode = selection.extentNode

    if (
      startIndex > endIndex || // swap because selection from bottom to top
      (startIndex === endIndex && anchorOffset > extentOffset)
    ) {
      // swap because bottom to top in same element
      let temp
      temp = startContainer
      startContainer = endContainer
      endContainer = temp
      temp = anchorNode
      anchorNode = extentNode
      extentNode = temp
      temp = anchorOffset
      anchorOffset = extentOffset
      extentOffset = temp
    }

    startContainer = $(startContainer).closest('[content-element]')
    endContainer = $(endContainer).closest('[content-element]')

    const prevFeature = startContainer.prev('[content-element]')
    const nextFeature = endContainer.next('[content-element]')

    $('.feature-focused').removeClass('feature-focused')

    if (selection.toString().length) {
      const lStart = walkTreeOffset(anchorNode, anchorOffset)

      let lHTMLStart = ''
      let lHTMLEnd = ''
      let elemToUpdate

      if (lStart !== 0) {
        elemToUpdate = startContainer
        lHTMLStart = splitHTMLAtIndex(
          startContainer.find('[contenteditable="true"]').html(),
          lStart
        )
        startContainer = startContainer.next()
      }

      if (extentNode.length > extentOffset) {
        const lEnd = walkTreeOffset(extentNode, extentOffset)
        lHTMLEnd = splitHTMLAtIndex(
          endContainer.find('[contenteditable="true"]').html(),
          lEnd
        )

        if (!elemToUpdate) {
          elemToUpdate = endContainer
        }

        if (startContainer !== endContainer) {
          endContainer = endContainer.prev()
        } else {
          endContainer = null
          startContainer = null
        }
      }

      if (elemToUpdate) {
        const ts = 'curFocus' + new Date().getTime()
        const updatedHTML =
          (lHTMLStart.lead || '') +
          `<span class='${ts}'></span>` +
          (lHTMLEnd.tail || '')
        $scope.story.content_elements[
          elemToUpdate.index() - 1
        ].content = updatedHTML
        placeCaretAfterSelectorWait('.' + ts)
      }

      selection.empty && selection.empty()
      selection.removeAllRanges && selection.removeAllRanges()
    }
    if (startContainer && endContainer) {
      notifyDelete(startContainer, endContainer)
    }

    if (prevFeature.length && !shouldfocusAfter) {
      prevFeature.addClass('feature-focused')
      let lastChild = prevFeature.children().last()
      if (lastChild.is('ul')) {
        lastChild = lastChild.find('li').last()
      }
      placeCaretAtEnd(lastChild[0])
      $scope.currentFocus -= 1
      updateFocus($scope.currentFocus)
    } else {
      nextFeature
        .addClass('feature-focused')
        .children()
        .not('.handles, [paste-options]')
        .first()
        .focus()
    }
  }

  function handleDelete(
    deleteElem,
    scope,
    contentElements,
    isRightDelete,
    keyEvent
  ) {
    const elemWrapper = $(deleteElem).closest('[content-element]')

    // Make sure that we have a next/prev sibling before deleting!
    const textObj = getTextBeforeAfter(deleteElem)

    // Clean text
    if ($('<div></div>').html(textObj.before).find('p').is(':empty')) {
      textObj.before = ''
    }

    if ($('<div></div>').html(textObj.after).find('p').is(':empty')) {
      textObj.after = ''
    }

    if (textObj.after === '<br>') {
      textObj.after = ''
    }

    const isEmpty = !textObj.before.length && !textObj.after.length
    const noLeadingText = !textObj.before.length
    const noTrailingText = !textObj.after.length
    const elementType = elemWrapper.data('type')
    // do not append to elements that aren't content-editable
    const isContentEditable = elemWrapper[0].isContentEditable
    if (elementType === 'list') {
      const lSel = window.getSelection()
      const aNode = lSel.anchorNode
      const eNode = lSel.extentNode
      const anLi =
        aNode.tagName === 'LI' ? aNode : aNode.parentElement.closest('li')
      const enLi =
        eNode.tagName === 'LI' ? eNode : eNode.parentElement.closest('li')
      const currentLi = $(anLi)
      const currentLiIndex = currentLi.prevAll('li').length
      const currentLiText = getTextBeforeAfter(currentLi.get(0))
      const ulIndex = $(currentLi).closest('[content-element]').data('orgIndex')
      const ulObjItems = contentElements[ulIndex].items

      if (anLi === enLi) {
        // Same element, running original code
        const prevElemLi = currentLi.prev()
        const nextElemLi = currentLi.next()

        const hasTextBefore = currentLiText.before.length
        const hasTextAfter = currentLiText.after.length

        // If there is text to delete allow it
        if (
          (hasTextBefore && hasTextAfter) || // has text before and after
          (hasTextBefore && !isRightDelete) || // has text before and delete towards left
          (hasTextAfter && isRightDelete)
        ) {
          // has text after and delete towards right
          return // tell the method to allow the default action
        } else if (isRightDelete && nextElemLi.length) {
          // Right delete and there is an li after it
          addContentToEndOfElement(currentLi, nextElemLi.html())
          nextElemLi.remove()
          ulObjItems.splice(currentLiIndex + 1, 1)
          currentLi.trigger('change')
          return true // tell the method we handled the action
        } else if (!isRightDelete && prevElemLi.length) {
          // Left delete and there is an li before it
          addContentToEndOfElement(prevElemLi, currentLi.html())
          currentLi.remove()
          ulObjItems.splice(currentLiIndex, 1)
          prevElemLi.trigger('change')
          return true
        } else if (!prevElemLi.length && !nextElemLi.length) {
          deleteFeature(textObj, isRightDelete)
          return true //  tell the method we handled the action
        } else {
          // Unknown case, just block it
          return true
        }
      } else {
        const lStart = walkTreeOffset(aNode, lSel.anchorOffset)
        const lEnd = walkTreeOffset(eNode, lSel.extentOffset)
        const lHTMLStart = splitHTMLAtIndex(anLi.innerHTML, lStart)
        const lHTMLEnd = splitHTMLAtIndex(enLi.innerHTML, lEnd)
        const enIndex = $(enLi).prevAll('li').length
        const ts = 'curFocus' + new Date().getTime()
        ulObjItems[currentLiIndex].content =
          lHTMLStart.lead + `<span class='${ts}'></span>` + lHTMLEnd.tail
        ulObjItems.splice(currentLiIndex + 1, enIndex - currentLiIndex)
        placeCaretAfterSelectorWait('.' + ts)
        return false
      }
    } else if (!isContentEditable && elementType !== 'text') {
      // elementType === 'table' || elementType === 'oembed_response'
      return false
    } else if (
      (isRightDelete &&
        !elemWrapper.next('[content-element]').length &&
        noTrailingText) ||
      (!isRightDelete &&
        !elemWrapper.prev('[content-element]').length &&
        noLeadingText)
    ) {
      const sel = window.getSelection()
      const startContainer = sel.baseNode.parentNode.closest(
        '[content-element]'
      )
      const endContainer = sel.extentNode.parentNode.closest(
        '[content-element]'
      )
      if (
        startContainer !== endContainer ||
        sel.anchorNode.textContent.trim() === sel.toString().trim()
      ) {
        deleteFeature(textObj)
      } else if (sel.deleteFromDocument) {
        sel.deleteFromDocument()
      }
      keyEvent && keyEvent.preventDefault && keyEvent.preventDefault()
      return sel.toString().length <= 1
    } else if (isRightDelete && noLeadingText && noTrailingText) {
      deleteFeature(elemWrapper)
      keyEvent && keyEvent.preventDefault && keyEvent.preventDefault()
      return true
    } else if (isRightDelete && !textObj.after.length) {
      const nextSib = elemWrapper.next('[data-type="text"]')
      const s = window.getSelection()
      if (s.rangeCount) {
        s.getRangeAt(0).deleteContents()
      }
      if (nextSib.length) {
        const ind = $(textObj.startContainer)
          .closest('[content-element]')
          .index()
        addContentToEndOfElement(
          $(deleteElem),
          nextSib.find('p[contenteditable="true"]').html()
        )
        scope.story.content_elements.splice(ind, 1)
      }
      keyEvent && keyEvent.preventDefault && keyEvent.preventDefault()
      return true
    } else if (isEmpty || (noLeadingText && !isRightDelete)) {
      if (isEmpty) {
        deleteFeature(textObj)
      } else {
        // if there is text behind the cursor, we need to add it to the previous paragraph.
        const wrapElem = elemWrapper.prev()
        if (!wrapElem.has('p, h1, blockquote').length) {
          return true
        }
        const prevElem = wrapElem.children().last()
        // Check if the previous ele is content-editable
        const isContentEditable = elemWrapper.prev()[0].isContentEditable
        if (prevElem.length && isContentEditable) {
          placeCaretAtEnd(prevElem.get(0))
          const ind =
            $(textObj.startContainer).closest('[content-element]').index() - 1
          // deleteFeature(textObj)  // remove the element
          const ts = 'curFocus' + new Date().getTime()
          addContentToEndOfElement(
            prevElem,
            `<span class='${ts}'></span>` + textObj.after
          )
          scope.story.content_elements.splice(ind, 1)
          placeCaretAfterSelectorWait('.' + ts)
        }
      }
      keyEvent && keyEvent.preventDefault && keyEvent.preventDefault()
      return true
    }
    return false
  }

  function addContentToEndOfElement(element, textToAdd) {
    const elementCE = element.find('[contenteditable="true"]')

    // Check if Parent wrapper or content-editable node
    if (elementCE.length) {
      element = elementCE
    }

    // remove all breaks
    element.find('br').remove()
    // set cursor
    placeCaretAtEnd(element.get(0))

    const restore = getCursorOffsetAndRestore(element.get(0))
    // last html node of parent container
    const lastChild = element.contents().last().get(0)

    if (lastChild && lastChild.nodeType === 3) {
      // If it is a text node, we should add to the text node
      const firstTag = textToAdd.indexOf('<') // Dirty check to see if we have html in it.
      if (firstTag > -1) {
        // if we have html
        if (firstTag !== 0) {
          // if we have text before it, than we need to add that portion to the text node
          lastChild.data = lastChild.data + textToAdd.substring(0, firstTag)
        }
        element.append(textToAdd.substring(firstTag)) // Add the remaining after the text node.
      } else {
        element.append(textToAdd) // add text node via jQuery
      }
      element[0].normalize() // native normalize to clean up nodes
    } else {
      // Sanitize HTML to prevent XSS attacks
      const sanitizedHTML = sanitize(textToAdd)
      // if it is not a text node at the end, just append it
      const contents = $('<div>').html(sanitizedHTML).contents()
      let remaining = contents
      if (lastChild && lastChild.nodeName === contents.get(0).nodeName) {
        // if the last and first node are the same, than combine the elements
        lastChild.innerHTML = lastChild.innerHTML + contents.get(0).innerHTML
        remaining = contents.slice(1)
      }
      element.append(remaining)
    }
    restore()
    $scope.currentFocus = element
      .closest('[content-element]')
      .trigger('change')
      .data('orgIndex')
    updateFocus($scope.currentFocus)
  }

  function getCursorOffsetAndRestore(element) {
    let sel = window.getSelection()
    let caretOffset
    let range
    if (sel.rangeCount > 0) {
      range = window.getSelection().getRangeAt(0)
      const preCaretRange = range.cloneRange()
      preCaretRange.selectNodeContents(element)
      preCaretRange.setEnd(range.endContainer, range.endOffset)
      caretOffset = preCaretRange.toString().length
    }
    return () => {
      if (caretOffset === undefined) {
        return
      }

      range = document.createRange()
      sel = window.getSelection()

      let currentNode = null
      let previousNode = null

      for (let i = 0; i < element.childNodes.length; i++) {
        previousNode = currentNode
        currentNode = element.childNodes[i]
        while (currentNode.childNodes.length > 0) {
          currentNode = currentNode.childNodes[0]
        }
        if (previousNode != null) {
          caretOffset -= previousNode.length
        }
        if (caretOffset <= currentNode.length) {
          break
        }
      }
      if (currentNode != null) {
        range.setStart(currentNode, caretOffset)
        range.collapse(true)
        sel.removeAllRanges()
        sel.addRange(range)
      }
    }
  }

  function updateTextElems(
    scope,
    wrapperElem,
    activeElem,
    insertLocation,
    items,
    pasting
  ) {
    const elemHtmlPortions = getTextBeforeAfter(activeElem)
    let selectionMethod = 'prev'
    let featureToBeInserted
    const insertBeforeElem =
      elemHtmlPortions.before.length === 0 &&
      elemHtmlPortions.after.length !== 0
    const tempAfterEmpty = !elemHtmlPortions.after.length
    const tempBeforeEmpty = !elemHtmlPortions.before.length
    const replaceCurrentFeat = pasting & tempBeforeEmpty && tempAfterEmpty
    let prevElem = null

    if (tempAfterEmpty) {
      elemHtmlPortions.after = '<br/>'
    }

    if (tempBeforeEmpty) {
      elemHtmlPortions.before = '<br/>'
    }

    if (insertBeforeElem) {
      featureToBeInserted = JSON.parse(JSON.stringify(items[insertLocation]))
      delete featureToBeInserted.$$hashKey
      delete featureToBeInserted._id
      featureToBeInserted.content = ''
    } else {
      const index = $(activeElem).closest('[content-element]').index() - 1

      if (!tempBeforeEmpty && !tempAfterEmpty) {
        prevElem = JSON.parse(
          JSON.stringify(scope.story.content_elements[index])
        )
        delete prevElem.$$hashKey
        prevElem.content = elemHtmlPortions.before
        // scope.story.content_elements[index].content = elemHtmlPortions.before
        // $(activeElem).find("[contenteditable='true']").html(elemHtmlPortions.before) // .trigger('input').trigger('change')
      }

      const ts = 'curFocus' + new Date().getTime()
      featureToBeInserted = {
        type: 'text',
        content: `<span class='${ts}'></span>` + elemHtmlPortions.after,
      } // needs _id from service
      selectionMethod = 'next'

      if (replaceCurrentFeat) {
        featureToBeInserted = null
        selectionMethod = 'prev'
      }

      insertLocation += replaceCurrentFeat ? 0 : 1
      placeCaretAfterSelectorWait('.' + ts)
    }

    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'updateTextElems',
        _id: wrapperElem._id || -1,
        selectionMethod,
        insertBeforeElem,
        tempAfterEmpty,
        tempBeforeEmpty,
        elemHtmlPortions,
        insertLocation,
      },
    })

    featureToBeInserted =
      featureToBeInserted && contentElementInflate(featureToBeInserted)

    const notElem = wrapperElem[selectionMethod]()

    if (prevElem && featureToBeInserted) {
      items.splice(insertLocation - 1, 1, prevElem, featureToBeInserted)
    } else if (featureToBeInserted) {
      items.splice(
        insertLocation,
        replaceCurrentFeat ? 1 : 0,
        featureToBeInserted
      )
    } else {
      items.splice(insertLocation, 1)
    }

    wrapperElem.addClass('dirty').trigger('change input')
    $('[contenteditablebind]').trigger('change input')

    function focusIt(inRetry) {
      const currentElement = wrapperElem[selectionMethod]()
      if (notElem.is(currentElement) || !currentElement.length) {
        if (inRetry === true) {
          return
        }
        window.setTimeout(() => focusIt(true), 1)
        return
      }

      wrapperElem.blur()
      currentElement.addClass('dirty')
      let currentFocus = $scope.currentFocus
      if (wrapperElem.is('li')) {
        focusElement(currentElement.get(0))
      } else {
        focusElement(currentElement.find('[contenteditable="true"]').get(0))
        currentFocus = currentElement.index() - 1
      }
      updateFocus(currentFocus)
    }
    !pasting && focusIt()
  }

  function focusElement(elem) {
    if (!elem) {
      return
    }
    try {
      elem.click()
      elem.focus()
      const selection = window.getSelection()
      const range = document.createRange()
      range.setStart(elem, 0)
      range.setEnd(elem, 0)
      selection.removeAllRanges()
      selection.addRange(range)
    } catch (e) {
      console.error('Problem focus element', e)
    }
  }

  function thirdPartyIntegration(scope, api, index) {
    let dialogElem = $('#dialog-new-feature')
    if (!dialogElem.length) {
      const template = `<div id="dialog-new-feature" title="">
                       <iframe id="dialog-new-feature-iframe"></iframe>
                     </div>`
      dialogElem = $(template).appendTo(document.body)
    }

    const ifr = $('#dialog-new-feature-iframe').attr('src', api)

    cleanupFunctions.push(() => $('#dialog-new-feature').dialog('destroy'))

    $('#dialog-new-feature').dialog({
      dialogClass: 'removeTitle',
      resizable: false,
      height: $(window).height() - 100,
      width: $(window).width() - 100,
      modal: true,
      buttons: {
        Cancel: {
          click: function () {
            $(this).dialog('close')
          },
          text: 'cancel',
          class: 'btn',
        },
        Select: {
          click: function () {
            ifr
              .get(0)
              .contentWindow.postMessage(
                'returnSelectedANS',
                window.location.origin
              )
            ifr.contents().find('.tools-row button.btn-green').click() // temp fix until they add listener
          },
          text: 'Select',
          class: 'btn btn-success',
        },
      },
      close: function () {
        window.removeEventListener('message', receiveMessage)
        $('#dialog-new-feature').remove()
      },
    })

    // Loops over and array of ANS objects (normalized or denormalized)
    // and injects them into the story content elements at the given index(es)
    const addANSElems = (ansElements) => {
      ansElements.forEach((item, i) => {
        // Gallery is giving us hashKey so need to clean it.
        if (item && item.$$hashKey) {
          delete item.$$hashKey
        }
        addNewElement(scope, index + i, item)
      })
    }

    const receiveMessage = function (evt) {
      const ans = evt.data instanceof Array ? evt.data : [evt.data]
      ansService
        .denormalize(ans)
        .then((items) => addANSElems(items))
        .catch(() => addANSElems(ans))
      $('#dialog-new-feature').dialog('close')
    }
    // Listen for the post message from the iframe.
    window.addEventListener('message', receiveMessage, false)
    cleanupFunctions.push(() =>
      window.removeEventListener('message', receiveMessage)
    )
  }

  function addNewElement($scope, index, ansObj) {
    // add stuff we need to inflate
    ansObj = contentElementInflate(ansObj)

    $rootScope.$broadcast('LOG_USER_EVENT', {
      event: {
        type: 'addNewElement',
        contentType: ansObj.type,
        index,
      },
    })

    if (['image'].indexOf(ansObj.type) !== -1) {
      ansObj.referent_properties = ansObj.referent_properties || {}
    }
    $scope.story.content_elements.splice(index, 0, ansObj)
    $scope.currentFocus = index
    storyService.setStoryProp('content_elements', $scope.story.content_elements)
    // only call modal if content element has property template
    const shouldOpen = contentTemplatesService.get(ansObj.type)
      .openPropertyTemplateOnAdd
    // only call modal if we say it should open on addnew elem
    // overlay now is angular-based (not jquery)
    // so we can simply set scope to control overlay/modal visibility
    angular.element('[content-element]').eq(index).addClass('dirty')
    if (shouldOpen) {
      $scope.focusedContent = {
        feature: $scope.story.content_elements[index],
        index,
      }
    }
    updateFocus($scope.currentFocus, true)
    pushCurrentElemStack()
  }

  $element.on('keyup', function (event) {
    const key = event.which
    if ([37, 38, 39, 40].indexOf(key) > -1) {
      const curFocus = $(window.getSelection().anchorNode).closest('[feature]')
      if (!curFocus.hasClass('feature-focused')) {
        curFocus.focus()
        curFocus.click()
      }
    }
  })

  // Construct a bit mask of features under cursoor or selection start
  // Should be under `contenteditable=true`, otherwise report no features
  const featuresMap = {
    I: TypographyFlags.ITALIC,
    B: TypographyFlags.BOLD,
    STRONG: TypographyFlags.BOLD,
    U: TypographyFlags.UNDERLINE,
    A: TypographyFlags.ANCHOR,
    DFN: TypographyFlags.COMMENT,
  }
  const getSelectionTypographyFeatures = () => {
    const selection = document.getSelection()
    let node = selection.anchorNode
    let features = 0
    if (!node) {
      return features
    }

    node = node.parentElement
    while (node) {
      const contentEditableAttribute = node.attributes.contenteditable
      if (
        contentEditableAttribute &&
        contentEditableAttribute.value === 'true'
      ) {
        return features
      }
      features |= featuresMap[node.nodeName] || 0
      node = node.parentElement
    }
    return 0
  }

  let lastCEB = null
  function typographyFeedbackSelectionListener(event) {
    const selectionFeatures = getSelectionTypographyFeatures()
    if (selectionFeatures !== $scope.selectionFeatures) {
      $scope.selectionFeatures = selectionFeatures
      $ngRedux.dispatch(typographyFeedbackAction(selectionFeatures))
    }

    const rSel = rangy.getSelection()
    currentyHasSelection = !rSel.isCollapsed

    // workaround from contenteditable eating blur/focus
    const cur = $(rSel.anchorNode).closest('[contenteditablebind]')
    if (!lastCEB || lastCEB[0] !== cur[0]) {
      cur.trigger('custFocus')
      if (lastCEB) {
        lastCEB.trigger('custBlur')
      }
      lastCEB = cur
      if (event.type !== 'selectionchange') {
        pushCurrentElemStack()
      }
    }
  }

  let currentyHasSelection = false

  cleanupFunctions.push(() =>
    $(document).off('selectionchange', typographyFeedbackSelectionListener)
  )
  $(document).on('selectionchange', typographyFeedbackSelectionListener)

  $element.on('keyup', function (event) {
    pushCurrentElemStack()
  })

  $element.on('keydown', function (event) {
    // Dismiss paste popover if any
    // pasteHolderFactory.dismissAll()

    // If we are in an input (property dialog) than ignore
    const anchorNode = window.getSelection().anchorNode
    const isInput = $(anchorNode).is(':input') || $(event.target).is(':input')
    if (isInput) {
      return true
    }

    // Triple click or mouse select beyond content element block
    // may delete ng-repeat comment node wich break Angular abitily to render ng-repeats
    ensureSafeSelection()

    // let isNonWords = event.key.match(/\W/) && anchorNode.textContent.length
    const key = event.which
    if (key >= K.left && key <= K.down) {
      // arrow keys
      return
    } else if (
      !isInput &&
      (event.ctrlKey || event.metaKey) &&
      (key === K.y || key === K.z)
    ) {
      if (key === K.y || (key === K.z && event.shiftKey)) {
        storyService.execRedo()
      } else {
        storyService.execUndo()
      }
      event.preventDefault()
      return false
    }

    const curFocus = $(window.getSelection().anchorNode).parent().get(0)
    // enter key at the end sometimes is the wrapper, not the last paragraph
    let result = false
    if (key === K.enter && !isInput) {
      if (currentyHasSelection && curFocus.nodeName !== 'LI') {
        result = !handleEnterSelection($scope, storyService, event)
      }
      if (!result) {
        result = handleEnter(curFocus, $scope, $scope.story.content_elements)
        result = true
      }
      // isNonWords = true
    } else if ((key === K.backspace || key === K.delete) && !isInput) {
      result = handleDelete(
        curFocus,
        $scope,
        $scope.story.content_elements,
        key === K.delete,
        event
      )
    }
    if (result) {
      const details = { type: constants.WORDCOUNT }
      const focusedElem = angular.element('.feature-focused')
      details.orgIndex = focusedElem.data('org-index')
      const focusedElemClone = focusedElem.clone()
      focusedElemClone
        .find('[paste-options], dfn, .handles, .js-formatting-popover')
        .remove()

      details.content = focusedElem
        .find('[contenteditable="true"]')
        .text()
        .trim()
        .replace(/(&nbsp;|\s)+/g, ' ')
      event.preventDefault()
      $rootScope.$broadcast('DISPATCH', details)
    } else {
      if (
        currentyHasSelection &&
        !(event.altKey || event.ctrlKey || event.metaKey) &&
        keyCodeCheck(key)
      ) {
        let typedChar = event.key
        if (['Delete', 'Backspace'].indexOf(typedChar) > -1) {
          typedChar = ''
        }
        const removeResp = handleRemove($scope, storyService, event, typedChar)
        try {
          $scope.$apply()
        } catch (e) {}

        return removeResp
      }
    }

    // if (isNonWords) {
    // if ($(anchorNode).is('[contenteditablebind]')) {
    // pushCurrentElemStack()
    // }
    // }
  })

  function pushCurrentElemStack() {
    // let details = {}
    // const ff = $('.feature-focused')
    // if (ff.length) {
    //   details = {
    //     index: ff.prevAll('[content-element]').length,
    //     editableHTML: ff.find('[contenteditablebind]').map((i, elm) => elm.innerHTML),
    //     cursor: null
    //   }
    // }
    // details.contentElements = JSON.stringify($scope.story.content_elements)
    // storyService.pushStoryState(details)
    storyService.pushContentElementState()
  }

  const keyCodeCheck = (cd) =>
    cd === 8 ||
    cd === 46 ||
    cd === 13 ||
    cd === 32 ||
    (cd > 47 && cd < 58) ||
    (cd > 64 && cd < 91) ||
    (cd > 95 && cd < 112) ||
    (cd > 185 && cd < 193) ||
    (cd > 218 && cd < 223)

  $element.on(
    'paste',
    handlePaste.bind(this, $scope, contentTemplatesService, storyService)
  )
  $element.on('cut', handleCutCopy.bind(this, $scope, storyService))
  $element.on('copy', handleCutCopy.bind(this, $scope, storyService))

  // Eric - I have no freaking clue why all of the sudden removing contenteditable
  // breaks this so adding an event to get blur to trigger change
  $element.off('focusout').on('focusout', (evt) => {
    const ceb = $(evt.originalEvent.srcElement)
      .closest('[contenteditablebind]')
      .trigger('change')
    if (!ceb.length) {
      $element.find('[contenteditablebind]').trigger('change')
    }
    onFeatureBlur(evt)
  })

  $scope.editAction = function (evt, action) {
    evt.preventDefault()
    evt.stopPropagation()
    document.execCommand(action)
  }

  $scope.moveToPasteboard = (currIndex) => {
    angular
      .element('.feature-focused [contenteditablebind]')
      .triggerHandler('change')
    const ce = $scope.story.content_elements.splice(currIndex, 1)[0]
    $scope.story.additional_properties =
      $scope.story.additional_properties || {}
    $scope.story.additional_properties.clipboard =
      $scope.story.additional_properties.clipboard || {}
    $scope.story.additional_properties.clipboard[ce.type] =
      $scope.story.additional_properties.clipboard[ce.type] || []
    $scope.story.additional_properties.clipboard[ce.type].push(ce)
    $rootScope.$broadcast('DISPATCH', { type: 'CLIPBOARD_MODIFIED' })
  }

  const editLinkPopoverTmpl = $element.find('div.ellipsis-hyperlink-popover')[0]

  const buildDraggableGhost = (focusedElem, ghostContent) => {
    const img = focusedElem.find('img')
    const text = $.trim(
      focusedElem.clone().children().not('.handles, [paste-options]').text()
    )

    if (img.length) {
      ghostContent.append(img.clone())
    }
    if (text.length) {
      ghostContent.append('<p>' + text + '</p>')
    } else if (focusedElem.data('placeholder')) {
      ghostContent.append(
        `<p data-placeholder="${focusedElem.data('placeholder')}"></p>`
      )
    }
  }

  // A hack to make sortable work after scrolling
  const refreshThrottled = throttle(
    () => $('#story-wrapper').sortable('refreshPositions'),
    500
  )

  cleanupFunctions.push(() => {
    const wrapper = $('#story-wrapper')
    if (wrapper.sortable('instance')) {
      wrapper.sortable('destroy')
    }
    wrapper.off('sortupdate click insertNewElement')
    wrapper.off('click', '.paste')
    wrapper.off('click', '.props')
    wrapper.off('click', 'a')
  })

  $('#story-wrapper')
    .sortable({
      axis: 'y',
      scroll: true,
      scrollSensitivity: 50,
      scrollSpeed: 35,
      handle: '.handles button.handle.move, figure.feature-wrapper',
      cancel: '', // needed when the handle is a button!
      forcePlaceholderSize: true,
      tollerance: 'intersect', // 'pointer',
      placeholder: 'sortable-placeholder',
      cursorAt: { top: 0, right: 5 },
      appendTo: '#main-content-scroll', // document.body,
      helper: function (evt) {
        const ghostContent = $('<div/>')
        const focusedElem = $('.feature-focused')
        if ($scope.multiSelectionState.hasSelection()) {
          // let focusedElem = $('[content-element].feature-selected--first')
          const $selected = $('[content-element].feature-selected')
          $selected.each((_, el) => buildDraggableGhost($(el), ghostContent))
        } else {
          buildDraggableGhost(focusedElem, ghostContent)
        }
        return $(
          '<p data-context="sorted-element" data-refid="' +
            focusedElem.data('context') +
            '" class="temp helper drag-view width-max-3"></p>'
        )
          .append(ghostContent)
          .height('100px')
      },
      start: function (e, ui) {
        $('[content-element].feature-selected', this).hide()
      },
      stop: function (e, ui) {
        $('[content-element].feature-selected', this).show()
      },
      sort: function () {
        refreshThrottled()
      },
    })
    .on('sortupdate', function on_sortupdate(evt, obj) {
      const newElem = $(obj.item)
      storyService.isDirty(true)

      if (newElem.is('[data-context="clipboard"]')) {
        // dragged on from the clipboard
        const id = newElem.data('id')
        const type = newElem.data('type')
        const index = newElem.prevAll('[content-element]').length

        let ansObj, i

        // Get the ANS details for the feature from the clipboard data
        const items = $scope.story.additional_properties.clipboard[type]
        for (i = 0; i < items.length; i++) {
          if (items[i]._id === id) {
            ansObj = items.splice(i, 1)[0]
            break
          }
        }

        // Add the item from the clipboard to the story body
        addNewElement($scope, index, ansObj)
        // get rid of the helper
        newElem.remove()
      } else if (newElem.is('[data-context="new-element"]')) {
        const type = newElem.data('type')
        const index = newElem.prevAll('[content-element]').length
        const api = contentTemplatesService.getApiService(type)
        const contentInit = contentTemplatesService.getInitialInflation(type)

        newElem.remove()

        if (api) {
          thirdPartyIntegration($scope, api, index)
        } else if (contentInit) {
          addNewElement($scope, index, contentInit)
        } else {
          addNewElement($scope, index, { type: type, content: '' })
        }
      } else if (newElem.is('[data-context="related-element"]')) {
        const index = newElem.prevAll('[content-element]').length
        newElem.remove()

        addNewElement($scope, index, $scope.draggedRelatedItem)
      } else {
        // if it was just sorted, update the new positioning
        if ($scope.multiSelectionState.hasSelection()) {
          const containIndexPredicate = R.compose(
            R.flip(R.any)($scope.multiSelectionState.getSelected()),
            (selIndex) => R.equals(R.__, selIndex)
          )
          const filterAgainstSelectedIndices = (modifier) =>
            R.addIndex(R.filter)(modifier(R.flip(containIndexPredicate)))(
              $scope.story.content_elements
            )

          const currIndex = obj.item.prevAll(
            '[content-element]:not(.feature-selected)'
          ).length

          // Angular sometimes behave weird with multiple elements update
          // so do a deep copy of content_elements
          $scope.story.content_elements = angular.copy(
            R.insertAll(
              currIndex,
              filterAgainstSelectedIndices(R.identity),
              filterAgainstSelectedIndices(R.complement)
            )
          )

          updateFocus(currIndex)
          $scope.multiSelectionState = $scope.multiSelectionState.getInitial()
        } else {
          const elem = obj.item
          const lastIndex = elem.attr('data-org-index')
          const currIndex = elem.prevAll('[content-element]').length
          // get ans from orginal position
          const ansElem = $scope.story.content_elements.splice(lastIndex, 1)
          // move to the new location
          $scope.story.content_elements.splice(currIndex, 0, ansElem[0])
          updateFocus(currIndex)
          pushCurrentElemStack()
        }
        $scope.$apply()
      }
    })
    .on('click', function on_click(evt) {
      /* Stop any clicks from inside of editor going to document - for unselection code below */
      evt.stopPropagation()
      $(window).trigger('input_click', evt) // need this for char map for chrome bug
    })
    .on('click', '.paste', function on_paste(evt) {
      /* Pasteboard pane icon */
      evt.stopPropagation()
      const currIndex = $('.feature-focused').attr('data-org-index')
      $scope.moveToPasteboard(currIndex)
    })
    .on('click', '.props', function on_props(evt) {
      /* Property pane icon */
      evt.stopPropagation()
      // var itemIndex = $(this).closest("[content-element]").data("org-index");
      // var objAns = $scope.story.content_elements.splice(itemIndex, 1);
      // $scope.$apply();
      /* TODO UNDO REDO */

      /* TODO send objAns to properties */
    })
    .on('insertNewElement', function (evt, type, ansObj) {
      let index = $('.feature-focused').attr('data-org-index')
      if (index === undefined) {
        index = $scope.story.content_elements.length
      } else {
        index++
      }

      /* TODO make fnc since copy paste from sort update */

      const api = contentTemplatesService.getApiService(type)
      const contentInit = contentTemplatesService.getInitialInflation(type)

      if (ansObj) {
        addNewElement($scope, index, ansObj)
      } else if (api) {
        thirdPartyIntegration($scope, api, index)
      } else if (contentInit) {
        addNewElement($scope, index, contentInit)
      } else {
        addNewElement($scope, index, { type: type, content: '' })
      }
    })
    .on('click', 'a', function (evt) {
      const linkIsWithinModal = (event) => {
        return $(event.target).parents('.modal-body').length > 0
      }

      if (linkIsWithinModal(evt)) {
        return
      }

      $scope.openEditLinkPopover(evt)
    })

  function hyperlinkCaptureClickHandler(whereClickedEvent) {
    if ($(whereClickedEvent.target).closest('.allow-click').length > 0) return
    $scope.togglePopover('hide')
  }

  cleanupFunctions.push(() =>
    window.removeEventListener('click', hyperlinkCaptureClickHandler)
  )
  //  capture clicks for closing the hyperlink edit menu popover
  window.addEventListener('click', hyperlinkCaptureClickHandler, {
    capture: true,
  })

  // TODO: Mike : This should probably be moved to the hyperlinkservices...
  $scope.openEditLinkPopover = function (event) {
    $scope.linkElementBeingEdited = $(event.target)

    //  ML - cleanup of selected-link that's inexplicably being added to the wrong link, don't know why exactly this happens
    $scope.story.content_elements = $scope.story.content_elements.map((e) => {
      if (e.type === 'text') {
        e.content = e.content.replace('class="selected-link"', '')
      } else if (e.type === 'list') {
        e.items.map((item) => {
          if (item.type === 'text' && item.content) {
            item.content = item.content.replace('class="selected-link"', '')
          }
          return item
        })
      }

      return e
    })

    // hyperlinkService.getSelectedLinkWithoutTrailingSlash(event.target.getAttribute('href')))

    hyperlinkService.initStoryLinkPopovers(event.target, editLinkPopoverTmpl)

    $scope.linkEditing = false

    // if init url, open edit mode
    if (event.target.pathname === '/TEMP-LINK-TEMP/') {
      $scope.linkEditing = true
      $scope.urlBeingEdited = ''
      $timeout(() => {
        $('input.edit-link-textbox').focus()
      }, 100)
    } else {
      const editingLink = $(event.target).closest('a').attr('href')
      $scope.urlBeingEdited = hyperlinkService.getSelectedLinkWithoutTrailingSlash(
        editingLink
      )
    }

    $scope.togglePopover('show')
  }

  $scope.togglePopover = (showOrHide) => {
    if (
      $scope.linkElementBeingEdited &&
      $scope.linkElementBeingEdited.length > 0
    ) {
      $scope.linkElementBeingEdited.popover(showOrHide)
    }
  }

  $scope.modifyLinkInContentElement = (urlBeingEdited, linkOpensInNewTab) => {
    const elemContainingLink = hyperlinkService.getContentElementContainingLink(
      $scope.story,
      $scope.linkElementBeingEdited
    )

    const $ceHTML = $('<div />', { html: elemContainingLink.content })
    const $linkBeingEdited = $ceHTML.find('a.selected-link')

    $linkBeingEdited
      .attr('href', urlBeingEdited)
      .removeClass('selected-link')
      .removeAttr('data-original-title')
      .removeAttr('aria-describedby')

    if (linkOpensInNewTab) {
      $linkBeingEdited.attr('target', '_blank')
    } else {
      $linkBeingEdited.removeAttr('target')
    }

    elemContainingLink.content = $ceHTML.html()

    toastr.success(
      intl.get('composeBody.modifyLinkInContentElement.success', {
        urlBeingEdited: urlBeingEdited,
      })
    )
  }

  cleanupFunctions.push(
    $rootScope.$on('RELATED_ITEMS_DRAG_START', (event, data) => {
      $scope.draggedRelatedItem = data.draggedRelatedItem
    })
  )

  // Mark that a content element is dirty and when we save, we loop over the elements
  // so we can update the models.
  $element.on('input', function () {
    storyService.isDirty(true)
  })

  /* Unselect element if click is outside of the story */
  function onFeatureBlur(evt) {
    if ($(evt.target).closest('.typographyButtons, story-toolbar').length)
      return
    if ($(evt.target).closest('.ellipsis-btn-select-option').length) return

    //  exit if it wasn't the main mouse button that triggered this click, focus will remain the same in this case
    if (evt.button !== 0) {
      return
    }

    const lastFocus = $('.feature-focused').removeClass('feature-focused')
    lastFocus.find('[contenteditablebind]').trigger('change')
    // $scope.currentFocus = -1
    updateFocus(-1, true)
  }
  $(window).on('click', onFeatureBlur)
  cleanupFunctions.push(() => $(window).off('click', onFeatureBlur))

  $scope.saveReferent = (feat, path, value) => {
    const imgObj = feat
    if (imgObj) {
      const parts = path.split('.')
      const last = parts.pop()
      const refObj = parts.reduce((o, prop) => {
        if (!o[prop]) {
          o[prop] = {}
        }
        return o[prop]
      }, imgObj)
      refObj[last] = value
    }
  }

  $scope.copyAll = () => {
    const ce = $('#story-wrapper')
      .clone()
      .find('[content-element]')
      .removeAttr('class content-element')
    ce.find('content-tools, content-comment').remove()
    ce.find('[contenteditable]').removeAttr('contenteditable')
    const d = $('<div></div>')
      .append(ce)
      .height(1)
      .width(1)
      .css('opacity', 0.1)
      .appendTo(document.body)
    const range = document.createRange()
    range.selectNodeContents(d[0])
    const sel = window.getSelection()
    sel.removeAllRanges()

    // This should never fail...but just incase there's black magic....
    if (range && range.startContainer !== document) {
      sel.addRange(range)
      document.execCommand('copy')
      d.remove()
      toastr.success(intl.get('composeBody.copyAll.success'))
    } else {
      toastr.warning(intl.get('composeBody.copyAll.warning'))
    }
  }

  $element.on('input paste cut', (e) => {
    const targElem = angular.element(e.target) // paragraph/headings
    let focusedElem = targElem.find('.feature-focused')
    if (!focusedElem.length) {
      // blockquote fires from inside
      focusedElem = targElem.closest('.feature-focused')
    }

    const temp = focusedElem.clone()
    temp.find('[paste-options], dfn, .handles, .js-formatting-popover').remove()
    $rootScope.$broadcast('DISPATCH', {
      type: constants.WORDCOUNT,
      orgIndex: focusedElem.data('org-index'),
      content: temp
        .text()
        .trim()
        .replace(/(&nbsp;|\s)+/g, ' '),
    })
  })

  cleanupFunctions.push(
    $rootScope.$on('BEFORE_SAVE', () => {
      // pasteHolderFactory.dismissAll()
    })
  )

  cleanupFunctions.push(
    $rootScope.$on('SAVE_SUCCESS', (evt, data) => {
      $scope.story = data.story
    })
  )

  // data: { action: string, index: int, feature: obj/feature } // index is content element index
  // evt: angular event ( from broadcast )
  // TODO: document type: contentElementAction
  cleanupFunctions.push(
    $rootScope.$on('UPDATE_CONTENT_ELEMENT', (evt, data) => {
      // pasteHolderFactory.dismissAll()
      switch (data.action) {
        case 'delete':
          $scope.deleteContentElement(data.index)
          break
        case 'convert':
          $scope.story.content_elements.splice(
            data.index,
            1,
            Object.assign({}, data.feature)
          )
          updateFocus(data.index)
          break
        case 'pasteboard':
          $scope.moveToPasteboard(data.index)
          break
        case 'properties':
          $scope.showPropModal(data.index)
          break
        case 'preview':
          $scope.openPreview(data.feature)
          break
        case 'channels':
          $rootScope.$broadcast('el.requestChannelsModal', data.feature)
          break
      }
    })
  )

  $scope.getEditState = () => {
    return !$scope.isRevision
  }

  $scope.$on('$destroy', () => {
    cleanupFunctions.forEach((fn) => fn())
    cleanupFunctions = null
    // pasteHolderFactory.dismissAll()
    // pasteHolderFactory.destroyAll()
  })
}
